export default __webpack_public_path__ + "f641e1fa0f9f47f93dc2fcff6795e4d0.png";